import { render, staticRenderFns } from "./SocialProfiles.vue?vue&type=template&id=461bec0e&scoped=true&"
import script from "./SocialProfiles.vue?vue&type=script&lang=js&"
export * from "./SocialProfiles.vue?vue&type=script&lang=js&"
import style0 from "./SocialProfiles.vue?vue&type=style&index=0&id=461bec0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461bec0e",
  null
  
)

export default component.exports